import { createFileRoute, Outlet } from "@tanstack/react-router";
import type { Session } from "@/features/auth/queries";
import { requireAccess } from "@/features/auth/route-guards";

/**
 * Everything that needs a signed-in player sits under this pathless layout,
 * guests included unless a page's `staticData.access` says otherwise. A
 * missing session returns to the page after sign-in.
 */
export const Route = createFileRoute("/_authenticated")({
  // Annotated because `matches` includes this route, which would otherwise type itself.
  beforeLoad: (args): Promise<{ session: Session }> => requireAccess(args),
  component: Outlet,
});
